// extracted by mini-css-extract-plugin
export default {"title":"MatchInfo_title__YBiJD","padding1em":"MatchInfo_padding1em__5zVme","boldFont":"MatchInfo_boldFont__JUtaV"};